// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Hamburg Menu
 * When the class of 'hamburg' is applied to the body tag of the document,
 * the sidebar changes it's style to attempt to mimic a menu on a phone app,
 * where the content is overlaying the content, rather than push it.
 */
@media only screen and (max-width: 560px) {
  body.hamburg #page-wrapper {
    padding-left: 0;
  }
  body.hamburg #page-wrapper:not(.open) #sidebar-wrapper {
    position: absolute;
    left: -100px;
  }
  body.hamburg #page-wrapper:not(.open) ul.sidebar .sidebar-title.separator {
    display: none;
  }
  body.hamburg #page-wrapper.open #sidebar-wrapper {
    position: fixed;
  }
  body.hamburg #page-wrapper.open #sidebar-wrapper ul.sidebar li.sidebar-main {
    margin-left: 0px;
  }
  body.hamburg #sidebar-wrapper ul.sidebar li.sidebar-main,
  body.hamburg .row.header .meta {
    margin-left: 70px;
  }
  body.hamburg #sidebar-wrapper ul.sidebar li.sidebar-main,
  body.hamburg #page-wrapper.open #sidebar-wrapper ul.sidebar li.sidebar-main {
    transition: margin-left 0.4s ease 0s;
  }
}
`, "",{"version":3,"sources":["webpack://./layout/resources/less/hamburg.less"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;EACE;IAEI,eAAA;EAAJ;EAFA;IAMM,kBAAA;IACA,YAAA;EADN;EANA;IAUM,aAAA;EADN;EATA;IAcI,eAAA;EAFJ;EAZA;IAgBM,gBAAA;EADN;EAfA;;IAoBI,iBAAA;EADJ;EAnBA;;IAuBI,oCAAA;EAAJ;AACF","sourcesContent":["/**\n * Hamburg Menu\n * When the class of 'hamburg' is applied to the body tag of the document,\n * the sidebar changes it's style to attempt to mimic a menu on a phone app,\n * where the content is overlaying the content, rather than push it.\n */\n@media only screen and (max-width:560px){\n  body.hamburg {\n    #page-wrapper {\n      padding-left: 0;\n    }\n    #page-wrapper:not(.open) {\n      #sidebar-wrapper {\n        position: absolute;\n        left: -100px;\n      }\n      ul.sidebar .sidebar-title.separator {\n        display: none;\n      }\n    }\n    #page-wrapper.open #sidebar-wrapper {\n      position: fixed;\n      ul.sidebar li.sidebar-main {\n        margin-left: 0px;\n      }\n    }\n    #sidebar-wrapper ul.sidebar li.sidebar-main, .row.header .meta {\n      margin-left: 70px;\n    }\n    #sidebar-wrapper ul.sidebar li.sidebar-main, #page-wrapper.open #sidebar-wrapper ul.sidebar li.sidebar-main {\n      transition: margin-left .4s ease 0s;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
